import TableColumn from '@/common/components/controls/table/TableColumn';

type ColumnsStore = {
  [key: string]: [number, number, 0 | 1]; // 0: index, 1: widthInPixels, 2: isVisible
};

class ColumnsSerializer {
  public static parse(value: string): Partial<TableColumn>[] {
    const parsedValue: ColumnsStore = JSON.parse(value);
    const output: Partial<TableColumn>[] = [];

    for (const [k, v] of Object.entries(parsedValue)) {
      if (!Array.isArray(v)) {
        continue;
      }
      output.push({
        key: k,
        index: v[0],
        widthInPixels: v[1],
        isVisible: v[2] === 1,
      });
    }
    return output;
  }

  public static stringify(columns: Partial<TableColumn>[]): string {
    const storedObject: ColumnsStore = {};

    for (const column of columns) {
      storedObject[column.key] = [column.index] as never;
      if (column.widthInPixels != null) {
        storedObject[column.key][1] = column.widthInPixels;
      }
      if (column.isVisible != null) {
        storedObject[column.key][2] = column.isVisible ? 1 : 0;
      }
    }
    return JSON.stringify(storedObject);
  }
}

export default ColumnsSerializer;
